/*
 * Copyright (c) 2023 Bolmate B.V.
 */
import './style/forgotPassword.scss';

import React, {FocusEventHandler, KeyboardEventHandler, MouseEventHandler, PureComponent} from 'react';
import {AwesomeIcon, ChangeFunction, ErrorType, Loader, preventDefault} from '@dvrd/dvr-controls';
import {BolmateButton, BolmateInput} from "../../../controls";
import Image from "../../../misc/image";

interface Props {
    onChange: ChangeFunction<string>;
    onSubmit: MouseEventHandler & KeyboardEventHandler;
    onResetError: FocusEventHandler;
    onClickBack: MouseEventHandler;
    email: string;
    error: ErrorType;
    loading: boolean;
}

export default class ForgotPassword extends PureComponent<Props> {
    render = () => {
        const {email, loading, error, onChange, onResetError, onSubmit, onClickBack} = this.props;
        return (
            <div className='forgot-password'>
                <div className='logo-header'>
                    <Image name='logo' className='logo'/>
                </div>
                <div style={{position: 'relative'}}>
                    <Loader active={loading}/>
                    <div className='header-container'>
                        <h1 className='header-title'>Wachtwoord opnieuw instellen</h1>
                        <label className='sub-title'>Vul je e-mailadres in om je wachtwoord opnieuw in te
                            stellen</label>
                    </div>
                    <form onSubmit={preventDefault} className='form'>
                        <BolmateInput value={email} onChange={onChange} label='E-mailadres' error={error}
                                      onFocus={onResetError}
                                      inputProps={{type: 'email', placeholder: 'Je e-mailadres'}} onEnter={onSubmit}
                                      disabled={loading}/>
                    </form>
                    <div className='btns-container'>
                        <BolmateButton onClick={onClickBack} label='Terug' secondary
                                       className='back-btn' ornaments={{element: <AwesomeIcon name='arrow-left'/>}}/>
                        <BolmateButton onClick={onSubmit} disabled={loading} label='Verzenden'/>
                    </div>
                </div>
            </div>
        )
    }
}